import { useUIStore } from '../../store/useUIStore';
import { AlertTriangle, Info } from 'lucide-react';

export function ConfirmDialog() {
    const confirmState = useUIStore(state => state.confirmState);
    const resolveConfirm = useUIStore(state => state.resolveConfirm);

    if (!confirmState) return null;

    const { title, message, confirmText = 'Aceptar', cancelText = 'Cancelar', isDangerous = false } = confirmState;

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm animate-fade-in px-4">
            <div
                className="bg-white rounded-2xl p-6 w-full max-w-md shadow-2xl animate-scale-up"
            >
                <div className="flex items-center gap-4 mb-4">
                    <div className={`p-3 rounded-full ${isDangerous ? 'bg-red-100 text-red-600' : 'bg-blue-100 text-blue-600'}`}>
                        {isDangerous ? <AlertTriangle className="w-6 h-6" /> : <Info className="w-6 h-6" />}
                    </div>
                    <h3 className="text-xl font-bold text-slate-800">
                        {title || 'Confirmar Acción'}
                    </h3>
                </div>

                <p className="text-slate-600 mb-6 text-sm">{message}</p>

                <div className="flex gap-3 justify-end">
                    <button
                        onClick={() => resolveConfirm(false)}
                        className="px-4 py-2 text-sm font-bold text-slate-600 hover:bg-slate-100 rounded-lg transition-colors border border-slate-200"
                    >
                        {cancelText}
                    </button>
                    <button
                        onClick={() => resolveConfirm(true)}
                        className={`px-4 py-2 text-sm font-bold text-white rounded-lg transition-colors shadow-sm
                            ${isDangerous
                                ? 'bg-red-600 hover:bg-red-700 focus:ring-4 focus:ring-red-100'
                                : 'bg-primary-600 hover:bg-primary-700 focus:ring-4 focus:ring-primary-100'
                            }`}
                    >
                        {confirmText}
                    </button>
                </div>
            </div>
        </div>
    );
}
